import { APP_NAME } from '../constants'

export let createActionType = (componentName = '', actionType = '') =>
  `${APP_NAME}/${componentName}/${actionType}`

export let createRequestActionTypes = (componentName = '', base = '') => {
  const res = {}

  if (componentName === '' || base === '') {
    console.warn(
      'createRequestActionTypes() componentName or base' +
        'arguments are not provided'
    )
  }

  ;['REQUEST', 'SUCCESS', 'FAILURE'].forEach(
    type => (res[type] = createActionType(componentName, `${base}_${type}`))
  )

  return res
}



// WEBPACK FOOTER //
// ./src/helpers/actions.js